import { css } from "styled-components";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
  }

  .blade-header-centered--super-title {
    ${chroma.typography.display7};
    color: ${paletteTokens.bladetext1};
    padding-bottom: ${chroma.spacers.variable.xs};
  }

  .blade-header-centered--title {
    ${chroma.typography.display3};
    color: ${paletteTokens.bladetext1};
    padding-bottom: ${chroma.spacers.variable.sm};
  }

  .blade-header-centered--subtitle {
    ${chroma.typography.body3};
    color: ${paletteTokens.bladetext1};
    font-weight: 600;
    padding-bottom: ${chroma.spacers.variable.xs};
  }

  .blade-header-centered--rich-text {
    ${chroma.typography.body3};
    color: ${paletteTokens.bladetext1};
    padding-bottom: ${chroma.spacers.variable.xl};
  }

  .blade-header-centered--link {
    padding-bottom: ${chroma.spacers.variable.xl};
    ${textUppercaseMixin};

    a {
      cursor: pointer;
    }
  }

  .blade-header-centered--super-title,
  .blade-header-centered--title,
  .blade-header-centered--subtitle,
  .blade-header-centered--rich-text,
  .blade-header-centered--link {
    margin: 0 auto;
  }
`;
//# sourceMappingURL=index.js.map